// extracted by mini-css-extract-plugin
export var Logo = "Testimonial-module--Logo--00fe3";
export var activeIndex = "Testimonial-module--activeIndex--6036e";
export var cMarginTop = "Testimonial-module--c-margin-top--2209f";
export var cPadding = "Testimonial-module--c-padding--41439";
export var cPaddingBottom = "Testimonial-module--c-padding-bottom--942a0";
export var cPaddingTop = "Testimonial-module--c-padding-top--074da";
export var col1 = "Testimonial-module--col1--0dc03";
export var col2 = "Testimonial-module--col2--30845";
export var column = "Testimonial-module--column--592dd";
export var companyLogo = "Testimonial-module--companyLogo--4a405";
export var content = "Testimonial-module--content--6cdf4";
export var content2 = "Testimonial-module--content2--e4ccc";
export var contentWithImage = "Testimonial-module--contentWithImage--00e74";
export var date = "Testimonial-module--date--07e3e";
export var designation = "Testimonial-module--designation--4bd82";
export var disabled = "Testimonial-module--disabled--e46c8";
export var ellipsis = "Testimonial-module--ellipsis--be3cb";
export var featuredSection = "Testimonial-module--featuredSection--4a0ef";
export var fullWidthContainer = "Testimonial-module--fullWidthContainer--89d95";
export var fullWidthContainerWithImage = "Testimonial-module--fullWidthContainerWithImage--63a99";
export var globalSpacing = "Testimonial-module--global-spacing--5ddb2";
export var globalSpacingBottom = "Testimonial-module--global-spacing-bottom--772ef";
export var globalSpacingTop = "Testimonial-module--global-spacing-top--eb427";
export var image = "Testimonial-module--image--cb15d";
export var imageTestimonial = "Testimonial-module--imageTestimonial--4aba3";
export var imageWrapper = "Testimonial-module--imageWrapper--ce841";
export var index = "Testimonial-module--index--528b3";
export var listItem = "Testimonial-module--listItem--1ec3e";
export var mainCol = "Testimonial-module--mainCol--90163";
export var maxWidth = "Testimonial-module--max-width--94051";
export var name = "Testimonial-module--name--09db0";
export var navButton = "Testimonial-module--navButton--2650a";
export var pagination = "Testimonial-module--pagination--ef9d8";
export var para = "Testimonial-module--para--25e46";
export var paraSection = "Testimonial-module--paraSection--85238";
export var stars = "Testimonial-module--stars--bf001";
export var styleTick = "Testimonial-module--styleTick--d8fae";
export var tag = "Testimonial-module--tag--09f3f";
export var tagWrapper = "Testimonial-module--tagWrapper--dc194";
export var text = "Testimonial-module--text--17c87";
export var title = "Testimonial-module--title--25547";